import { useState } from 'react';
import { T, Ico, Card, Eyebrow, Btn } from '../../../design';
import type { Course, SalonEmployee } from '../../../types/courses.types';
import { fmtDate, fmtPrice } from '../../../utils';
import { availInfo } from '../courseUtils';
import { PersonRow } from './PersonRow';

export interface BulkEnrollProps {
  course: Course;
  employees: SalonEmployee[];
  submitting: boolean;
  onSubmit: (employeeIds: number[]) => void;
}

export function BulkEnroll({ course, employees, submitting, onSubmit }: BulkEnrollProps) {
  const [sel, setSel] = useState<Set<number>>(new Set());
  const toggle = (id: number) => setSel((p) => { const n = new Set(p); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const av = availInfo(course);
  const spotsLabel = av.disabled ? 'Afsluttet' : av.full ? 'Fuldt' : av.label;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14, paddingBottom: 92 }}>
      <Card pad={14}>
        <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: T.fg3 }}>Tilmeld hold til</div>
        <div style={{ fontSize: 16, fontWeight: 800, color: T.fg, marginTop: 4 }}>{course.productName}</div>
        <div style={{ fontSize: 12.5, color: T.fg3, fontWeight: 600, marginTop: 3 }}>{fmtDate(course.courseDate)} · {fmtPrice(course.price)} · {spotsLabel}</div>
        <div style={{ fontSize: 11.5, color: T.fg3, fontWeight: 600, marginTop: 8, display: 'flex', gap: 6 }}><Ico.info size={14} style={{ flexShrink: 0, marginTop: 1 }} />Bulk-tilmeldte godkendes med det samme — ingen kø.</div>
      </Card>
      <Eyebrow>Vælg medarbejdere</Eyebrow>
      <Card pad={0}>
        {employees.map((emp) => <PersonRow key={emp.id} name={emp.name} owner={emp.isOwner} selectable selected={sel.has(emp.id)} onClick={() => toggle(emp.id)} />)}
      </Card>
      <div style={{ position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 30, background: T.surface, borderTop: `1px solid ${T.border}`, padding: '12px 14px calc(12px + env(safe-area-inset-bottom))', maxWidth: 440, margin: '0 auto' }}>
        <Btn full size="lg" disabled={sel.size === 0 || submitting} onClick={() => onSubmit([...sel])} icon={<Ico.users size={18} />}>Tilmeld {sel.size > 0 ? sel.size : ''} medarbejdere</Btn>
      </div>
    </div>
  );
}
